"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _lodash = require("lodash");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('underscore'),
  extend = _require.extend,
  findWhere = _require.findWhere,
  flatten = _require.flatten,
  isArray = _require.isArray,
  isEmpty = _require.isEmpty,
  isObject = _require.isObject,
  isString = _require.isString,
  last = _require.last,
  partial = _require.partial,
  sortBy = _require.sortBy,
  object = _require.object;
var hasIconCorrectFormat = function hasIconCorrectFormat(icon) {
  return /file\.(png|jpeg|jpg|gif)$/i.test(icon);
};
angular.module('backstage.directives.externals').directive('bsDefaultExternalComboWidget', ['$rootScope', function ($rootScope) {
  return {
    templateUrl: '/static/partials/components/default-external-combo-widget.html',
    require: '?ngModel',
    priority: 100,
    scope: {
      model: '=ngModel',
      fieldDescriptor: '=',
      field: '=',
      label: '=',
      hideLabel: '=',
      hideCreateButton: '=',
      disableOptionsRemove: '=',
      options: '=',
      showAddButtonInHeader: '=',
      isBulkEdit: '=',
      bulkFieldOptions: '='
    },
    link: function link(scope, elem, attr, ctrl) {
      ctrl.$validators.required = function (modelValue, viewValue) {
        var isRequired = ((scope.fieldDescriptor || {}).validations || {}).required;
        return !(isRequired && ctrl.$touched && ctrl.$isEmpty(viewValue[scope.fieldDescriptor.field]));
      };
      scope.$watch('model[fieldDescriptor.field]', function (newValue, oldValue) {
        if (newValue !== undefined && oldValue !== newValue) {
          if (scope.modelCleaned) {
            $rootScope.setNavigationWarningMessage(null);
            scope.modelCleaned = false;
          } else {
            ctrl.$setTouched();
            ctrl.$validate();
          }
        }
      });
      var fieldValues = scope.model[scope.field];
      if (!fieldValues) {
        return;
      }
      if (!isArray(fieldValues)) {
        fieldValues = [fieldValues];
      }
      if (scope.type === 'icon' && scope.idField === 'fp_asset') {
        fieldValues = fieldValues.map(function (id) {
          return hasIconCorrectFormat(id) ? id : "".concat(id, "/file.png");
        });
      }
      scope.backlinksService.queryBacklinksWithKeys(scope.eventId, scope.type, scope.idField, fieldValues).then(function (list) {
        var fieldId = (0, _lodash.get)(scope.options, 'id_field') || 'fp_ext_id';
        if (isArray(scope.model[scope.field])) {
          var prevCount = scope.model[scope.field].length;
          var backlinksLookup = object(list.filter(function (doc) {
            return doc;
          }).map(function (doc) {
            return [doc[scope.idField], doc[fieldId]];
          }));
          scope.model[scope.field] = scope.model[scope.field].map(function (val) {
            return backlinksLookup[val] || val;
          });
          if (prevCount !== scope.model[scope.field].length) {
            scope.modelCleaned = true;
          }
        }
        if (scope.single_doc) {
          var prevValue = scope.model[scope.field];
          if (list.length && list[0]) {
            scope.model[scope.field] = list[0][fieldId];
          }
          if (prevValue !== scope.model[scope.field]) {
            scope.modelCleaned = true;
          }
        }
      });
    },
    controller: 'DefaultExternalComboWidgetCtrl'
  };
}]);
angular.module('backstage.directives.externals').directive('bsSpeakersSelectorComboWidget', [function () {
  return {
    templateUrl: '/static/partials/components/default-external-combo-widget.html',
    require: '?ngModel',
    priority: 100,
    scope: {
      model: '=ngModel',
      fieldDescriptor: '=',
      field: '=',
      label: '=',
      hideLabel: '=',
      hideCreateButton: '=',
      disableOptionsRemove: '=',
      options: '=',
      showAddButtonInHeader: '='
    },
    link: function link() {
      return console.warn('DEPRECATED. bs-speakers-selector-combo-widget is deprecated, ' + 'use bs-external-default-combo-widget instead');
    },
    controller: 'DefaultExternalComboWidgetCtrl'
  };
}]);
angular.module('backstage.directives.externals').controller('DefaultExternalComboWidgetCtrl', /* @ngInject */["$log", "$q", "$scope", "$rootScope", "$filter", "userService", "urlService", "eventService", "metadataService", "backlinksService", "bulkUpdateService", "essenceManager", "$timeout", "$element", function ($log, $q, $scope, $rootScope, $filter, userService, urlService, eventService, metadataService, backlinksService, bulkUpdateService, essenceManager, $timeout, $element) {
  var _collectionWatchCb2, legacyModeDetectionPromise;
  var LABEL_SEARCH_MINIMUM_INPUT_LENGTH = 0;
  var LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX = 5;
  var CREATE_NEW_ITEM_SPECIAL_KEY = $scope.CREATE_NEW_ITEM_SPECIAL_KEY = '__CREATE_NEW__';
  var options = $scope.options || {};
  $scope.backlinksService = backlinksService;
  $scope.fetchAndMapItems = fetchAndMapItems;
  extend($scope, options);
  $scope.idField = options.id_field;
  var idField = $scope.idField || 'fp_ext_id';
  $scope.fpExtIdToAdd = {};
  $scope.displaySubtypes = $scope.subtypes || [$scope.type];
  var cachedSortedItemList = $scope.cachedSortedItemList = [];
  var cachedIdToNameMappings = $scope.cachedIdToNameMappings = {};
  var cachedIdToStatusMappings = {};
  var cachedIdToAssetMappings = {};
  var event = eventService.getCurrentEvent();
  var eventId = $scope.eventId = event._id;
  var eventNode = event.node;
  var metadataForType = metadataService.getCachedMetadataForType(eventId, $scope.type);
  var metadataFieldsForNewItem = $scope.metadataFieldsForNewItem = [];
  var metadataForTypeArray = metadataService.getCachedMetadataForTypeAsArray(eventId, $scope.type);
  var isInvitedByLink = userService.isInvitedByLink(event);
  $scope.isInvitedByLink = isInvitedByLink;

  // filter out fields hidden for users invited by accredited link without proper event role
  if (isInvitedByLink) {
    var forbiddenFieldTypes = ['external', 'nested-object', 'list', 'custom'];
    metadataForTypeArray = metadataForTypeArray.filter(function (field) {
      return !(0, _lodash.get)(field, 'hideForInvited') && !((0, _lodash.get)(field, 'is_custom_field') && forbiddenFieldTypes.includes((0, _lodash.get)(field, 'kind')));
    });
  }
  var watchedCollection = [];
  $scope.isSaving = false;
  $scope.isInLegacyModeDetermined = false;
  $scope.getIdsArrayForSubType = getIdsArrayForSubType;
  $scope.getHumanizedType = getHumanizedType;
  $scope.editFields = metadataForTypeArray;
  if ($scope.isBulkEdit && !$scope.single_doc) {
    // if we are in bulk edit mode, and the external selector is not a single select...
    $scope.bulkFieldOptions[$scope.field] = 'add-to-existing';
  }
  $scope.getItemCreationVerb = function () {
    if (options.item_creation_verb) return options.item_creation_verb;
    return $scope.formEssence && $scope.formEssence.itemCreationVerb ? $scope.formEssence.itemCreationVerb : 'Create';
  };
  $scope.getHumanizedTypeCountTooltipText = function () {
    if (!isEmpty(cachedSortedItemList)) {
      var count = cachedSortedItemList.length;
      var pluralSuffix = count > 1 ? 's' : '';
      return "".concat(count, " ").concat(getHumanizedType()).concat(pluralSuffix, " available");
    }
  };
  $scope.canAddAnItem = function (subtype) {
    var idsArrayLength = (getIdsArrayForSubType(subtype) || []).length;
    if ($scope.options.maxNumber && idsArrayLength >= $scope.options.maxNumber) {
      return false;
    }
    return !$scope.single_doc || !idsArrayLength;
  };
  $scope.canCreateAnItem = function () {
    return metadataForTypeArray && metadataForTypeArray.length > 0;
  };
  $scope.getHeadingRowTextForType = function (subtype) {
    if ($scope.subtypes) {
      return subtype;
    }
    return $scope.label || (metadataForType[$scope.field] || {}).label || $scope.field;
  };
  $scope.getIdForDoc = function (doc) {
    return doc[idField] || doc._id;
  };
  $scope.getDisplayNameForId = function (fpExtId) {
    return cachedIdToNameMappings[fpExtId] || $scope.fpExtIdMap && $scope.fpExtIdMap[fpExtId] || fpExtId;
  };
  $scope.getCrudHyperlinkForId = function (fpType, fpExtId) {
    if (!urlService.isValidAppRoute("/event/:eventId/".concat(fpType, "s/:modelId"))) {
      return null;
    }
    var _id = (findWhere(cachedSortedItemList, _defineProperty({}, idField, fpExtId)) || {})._id;
    if (!_id) {
      return '';
    }
    return "/event/".concat(eventId, "/").concat(fpType, "s/").concat(_id);
  };
  var imageFormats = ['jpg', 'jpeg', 'png', 'gif'];
  $scope.getAssetUrlForId = function (fpExtId) {
    var asset = cachedIdToAssetMappings[fpExtId];
    if (!asset) {
      return;
    }
    if (imageFormats.indexOf(last(asset.split('.'))) === -1) {
      return;
    }
    return "/api/v1/events/".concat(eventId, "/assets/").concat(asset);
  };
  $scope.getIconClassForType = function () {
    switch ($scope.type) {
      case 'person':
      case 'presenter':
        return 'icon-user';
      case 'session':
        return 'icon-calendar';
      default:
        return 'icon-link';
    }
  };
  $scope.getVisibilityClassesForId = function (fpExtId) {
    switch (cachedIdToStatusMappings[fpExtId]) {
      case 'cancelled':
        return 'translucent';
      case 'hidden':
        return 'translucent';
      default:
        return '';
    }
  };
  $scope.revealAddDropdownControls = function () {
    if ($scope.isInLegacyMode && !(cachedSortedItemList ? cachedSortedItemList.length : undefined)) {
      // if the list is empty we'll try to fetch again
      // (this is particularly useful when the user has just created a new item in a new tab/window and wants to see the list refresh)
      $scope.loading = true;
      eventService.getEventDocsByType(event, $scope.type).then(legacyGetEventDocsByTypeCb);
    }
    $scope.showAddControls = true;
    $timeout(function () {
      $element.find('.btn-add-item').select2('open');
    }, 250);
  };
  $scope.openCreateNewItemModal = function (fpType, subtype) {
    // special types that require the normal create page, because it's custom
    if (fpType === 'live_stream') {
      return window.open("/event/".concat(eventId, "/live_streams/new"), '_blank');
    }
    if (fpType === 'content-video' || fpType === 'content-document') {
      var scope = options.scope || '';
      var defaultMimes = fpType === 'content-video' ? ['video/mp4'] : ['application/pdf'];
      var acceptedMimes = options.accepted_mimes || defaultMimes;
      var context = options.context || {};
      var detail = {
        scope: scope,
        context: context,
        acceptedMimes: acceptedMimes
      };
      var _event = new CustomEvent('start-uploader', {
        detail: detail
      });
      window.dispatchEvent(_event);
      return;
    }
    $scope.newItemCreationParams = {
      type: fpType,
      subtype: subtype,
      metadata: metadataForTypeArray
    };
    var _defaults = metadataService.extractDefaults(metadataForTypeArray);
    $scope.newItemFpType = fpType;
    $scope.newItemModel = extend({}, _defaults, {
      fp_type: fpType
    });
    $scope.showAddControls = false;
    $rootScope.setNavigationWarningMessage(null);
    angular.copy(metadataForTypeArray, metadataFieldsForNewItem);
    $scope.previousCachedSortedItemList = (0, _lodash.cloneDeep)(cachedSortedItemList);
    angular.copy([], cachedSortedItemList); // to empty the existing item list
  };
  $scope.closeCreateNewItemModal = function () {
    angular.copy($scope.previousCachedSortedItemList, cachedSortedItemList);
    $scope.newItemCreationParams.type = null;
    $scope.isSaving = false;
    watchedCollection = [];
    ($scope.displaySubtypes || []).forEach(function (subType) {
      getIdsArrayForSubType(subType, true);
    });
  };
  $scope.submit = function (saveModel) {
    var _arguments = arguments,
      _this = this;
    var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $scope.newItemModel;
    var form = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var subtype = $scope.newItemCreationParams.subtype;
    if (!saveModel || form.$invalid) {
      return;
    }
    if ($scope.formEssence.name === 'asset') {
      // assets have already been on a trip to the server so we must override their inherent attributes
      extend(model, $scope.newItemModel);
    }
    $scope.isSaving = true;
    return $scope.formEssence.save(model, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(model, fpType) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return saveModel(model, fpType, true);
            case 2:
              result = _context.sent;
              if (!result.error) {
                _context.next = 5;
                break;
              }
              throw result.error;
            case 5:
              if (!$scope.isInLegacyMode) {
                _context.next = 12;
                break;
              }
              $scope.loading = true;
              _context.next = 9;
              return eventService.getEventDocsByType(event, $scope.type, {
                cached: true
              });
            case 9:
              return _context.abrupt("return", legacyGetEventDocsByTypeCb.apply(_this, _arguments));
            case 12:
              return _context.abrupt("return", backlinksService.triggerAndWaitForBacklinksRefresh(eventId));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()).then(function () {
      $scope.addFpExtIdAsSubType(subtype, model[idField]);
    }).then(function () {
      $scope.newItemCreationParams.type = null; // this hides the modal
    }).catch(function () {
      $scope.removeFpExtIdFromSubType(subtype, model[idField]);
    }).finally(function () {
      $scope.isSaving = false;
    });
  };
  $scope.addFpExtIdAsSubType = function (subtype, fpExtId) {
    var ids = getIdsArrayForSubType(subtype, true);
    if (!isString(fpExtId)) {
      return;
    }
    // are we creating a new item via the shortcut dropdown item?
    if (fpExtId === CREATE_NEW_ITEM_SPECIAL_KEY) {
      return $scope.openCreateNewItemModal($scope.type, subtype);
    }
    if (Array.from(ids).includes(fpExtId)) {
      return $rootScope.setNavigationWarningMessage(null);
    }
    if ($scope.single_doc) {
      $scope.model[$scope.field] = fpExtId;
    } else {
      ids.push(fpExtId);
    }
  };
  $scope.removeFpExtIdFromSubType = function (subtype, fpExtId) {
    var model = $scope.model,
      field = $scope.field;
    var ids = getIdsArrayForSubType(subtype, true);
    var idx = ids.indexOf(fpExtId);
    if (!ids || idx === -1) {
      return;
    }
    if ($scope.single_doc) {
      model[field] = null;
    } else {
      ids.splice(idx, 1);
    }
  };
  $scope.pullItemUp = function (subtype, fpExtId) {
    var ids = getIdsArrayForSubType(subtype, true);
    var idx = ids.indexOf(fpExtId);
    if (idx === 0) {
      return;
    }
    ids.splice(idx - 1, 0, ids.splice(idx, 1)[0]);
  };
  $scope.pushItemDown = function (subtype, fpExtId) {
    var ids = getIdsArrayForSubType(subtype, true);
    var idx = ids.indexOf(fpExtId);
    if (idx === ids.length - 1) {
      return;
    }
    ids.splice(idx + 1, 0, ids.splice(idx, 1)[0]);
  };
  $scope.navigate = function () {
    if ($rootScope.navigationWarningMessage && !confirm('You will lose any unsaved data on this page upon navigating away. Proceed?')) {
      return;
    }
    return $rootScope.navigate.apply($scope, arguments);
  };
  init();

  /** *********** */
  /* FUNCTIONS  */
  /** *********** */

  function getHumanizedType() {
    return $filter('humanize')($scope.type);
  }
  function legacyGetEventDocsByTypeCb(evDocsListData) {
    var _list = (evDocsListData || {}).data;
    if (_list) {
      return fetchAndMapItems(_list);
    }
  }
  function getIdsArrayForSubType(subtype, createDefault) {
    var model = $scope.model,
      field = $scope.field;
    if (!model || !field) {
      return [];
    }
    if (createDefault) {
      // set the default field value
      // if single_doc then this is an empty string
      // if we have subtypes it's an empty object
      // or we'll set an empty array (to be filled with fp_ext_ids)

      var defaultFieldValue;
      if ($scope.single_doc) {
        defaultFieldValue = '';
      } else if ($scope.subtypes) {
        defaultFieldValue = {};
      } else {
        defaultFieldValue = [];
      }
      if (!model[field]) {
        model[field] = defaultFieldValue;
      }
    }

    // now return the array of ids that we'll use to render the list
    if ($scope.single_doc) {
      if (isEmpty(model[field])) {
        return [];
      }
      watchedCollection = flatten([model[field]]);
    } else if ($scope.subtypes) {
      // initialize default value if needed
      if (model[field]) {
        if (!model[field][subtype] && createDefault) {
          model[field][subtype] = [];
        }
      }
      watchedCollection = (model[field] || {})[subtype] || [];
    } else {
      if (!isEmpty(model[field]) && !isArray(model[field])) {
        model[field] = [model[field]];
      }
      watchedCollection = model[field] || [];
    }
    if (!isArray(watchedCollection)) {
      console.warn("Wrong value for field ".concat(field, ": ").concat(watchedCollection, ". It should be an array."));
      watchedCollection = [];
    }
    return watchedCollection;
  }
  function triggerLegacyModeFetchAndMapItems() {
    $scope.loading = true;
    return eventService.getEventDocsByType(event, $scope.type, {
      cached: true
    }).then(legacyGetEventDocsByTypeCb);
  }
  if ($scope.isInLegacyModeDetermined) {
    if ($scope.isInLegacyMode) {
      triggerLegacyModeFetchAndMapItems();
    }
  } else {
    legacyModeDetectionPromise.then(function () {
      if ($scope.isInLegacyMode) {
        return triggerLegacyModeFetchAndMapItems();
      }
    });
  }
  function init() {
    if ($scope.subtypes) {
      // backlinks not available when using subtypes
      $scope.isInLegacyMode = true;
      $scope.isInLegacyModeDetermined = true;
    } else {
      legacyModeDetectionPromise = backlinksService.isBacklinksSearchAvailable(eventId, eventNode).then(function (isBacklinksSearchAvailable) {
        $scope.isInLegacyModeDetermined = true;
        $scope.isInLegacyMode = !isBacklinksSearchAvailable;
        if ($scope.isInLegacyMode) {
          return $scope.select2Options = {
            placeholder: 'Choose an item',
            minimumResultsForSearch: LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX
          };
        }
        // go remote
        var handlerUrl = backlinksService.getSearchHandlerUrl(eventId, $scope.type);
        return $scope.select2Options = {
          placeholder: 'Find an item',
          minimumInputLength: LABEL_SEARCH_MINIMUM_INPUT_LENGTH,
          minimumResultsForSearch: LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX,
          ajax: {
            url: handlerUrl,
            dataType: 'json',
            quietMillis: 250,
            data: function data() {
              var term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
              return {
                query: term.length ? term : ' ',
                field: idField
              };
            },
            results: function results() {
              var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var field = $scope.model[$scope.field];
              if (field) {
                var ids = field;
                if (isObject(field[0])) {
                  ids = field.map(function (o) {
                    return o.id || o._id || o.fp_ext_id;
                  });
                }
                list = list.filter(function (i) {
                  return !ids.includes(i.id || i._id || i.fp_ext_id);
                });
              }
              return {
                results: list
              };
            },
            cache: false
          }
        };
      }).catch(function () {
        // fall back to legacy mode on error
        $scope.isInLegacyMode = true;
        $scope.isInLegacyModeDetermined = true;
      });
    }
    essenceManager.addEssenceToForm(metadataForType._essence, metadataForTypeArray, $scope.type).then(function (formEssence) {
      $scope.formEssence = formEssence;
    });
    $scope.$watchCollection(function () {
      return watchedCollection;
    }, _collectionWatchCb2 = function collectionWatchCb(collection) {
      if (!(collection ? collection.length : undefined)) {
        return;
      }

      // if we don't know if we're in legacy mode wait until we do know
      if (!$scope.isInLegacyModeDetermined) {
        var _collectionWatchCb = partial(_collectionWatchCb2, collection);
        return legacyModeDetectionPromise.then(_collectionWatchCb, _collectionWatchCb);
      }
      if (!$scope.isInLegacyMode) {
        $scope.loading = true;
        backlinksService.queryBacklinksWithKeys(eventId, $scope.type, idField, collection).then(function (list) {
          $scope.loading = false;
          return fetchAndMapItems(list);
        });
      }
    });
  }
  function fetchAndMapItems(docsList) {
    // ⚑ UNAVOIDABLE HACK ALERT
    // TODO: REMOVE this when we have fully transitioned away from hosted_docs
    docsList = docsList.map(function (_doc) {
      var ext, props;
      if (!_doc._id || _doc.fp_type !== 'hosted_doc') {
        return _doc;
      }
      if (!(props = _doc.bs_fileprops) || !(ext = props.extension)) {
        return _doc;
      }
      if (_doc._id.substring(_doc._id.length - (ext.length + 1)) === ".".concat(ext)) {
        return _doc;
      }
      _doc._id = "".concat(_doc._id, ".").concat(ext);
      return _doc;
    });
    var idToNameMappings = docsList.reduce(function (memo, doc) {
      var reprLabel = metadataService.getReprLabelForItem(eventId, doc);
      var fallbackLabel = function () {
        switch ($scope.type) {
          case 'person':
            return doc.fullname || "".concat(doc.fname, " ").concat(doc.lname);
          default:
            return doc.name && doc.name.en || doc.name || doc.title || doc.subject || doc.label || doc.fp_ext_id || doc._id;
        }
      }();
      memo[doc[idField]] = reprLabel || fallbackLabel;
      return memo;
    }, {});
    angular.extend(cachedIdToNameMappings, idToNameMappings);
    var idToStatusMappings = docsList.reduce(function (memo, doc) {
      if (doc.fp_status) {
        memo[doc[idField]] = doc.fp_status;
      }
      return memo;
    }, {});
    angular.extend(cachedIdToStatusMappings, idToStatusMappings);
    var filteredSortedItemList = $filter('filterOutPaxWithFpStatusCancelled')(sortBy(docsList, 'fname', 'title'));
    angular.copy(filteredSortedItemList, cachedSortedItemList);
    var idToAssetMappings = docsList.reduce(function (memo, doc) {
      if (doc.fp_asset) {
        memo[doc[idField]] = doc.fp_asset;
      }
      return memo;
    }, {});
    angular.extend(cachedIdToAssetMappings, idToAssetMappings);
    return $scope.loading = false;
  }
  if ($scope.canCreateAnItem()) {
    cachedIdToNameMappings[CREATE_NEW_ITEM_SPECIAL_KEY] = 'Create a new item';
    $scope.isCreateNewItemRouteAvailable = true;
  }
  $scope.openEditItemModal = function (fpExtId) {
    return backlinksService.queryBacklinksWithKeys(eventId, $scope.type, idField, [fpExtId]).then(function (result) {
      var doc = result[0];
      if ($scope.type === 'person') {
        return eventService.getEventParticipantInfoAndTimeline(event, doc._id).then(function (result) {
          return result.data;
        });
      } else {
        return doc;
      }
    }).then(function (doc) {
      $scope.editModel = doc;
      $scope.showEditModal = true;
    });
  };
  $scope.saveUpdatedModel = function (model) {
    var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (form.$invalid) {
      return;
    }
    $scope.isSavingEdit = true;
    return bulkUpdateService.updateDoc(eventId, eventNode, model.fp_type, model).then(function () {
      $rootScope.setFlashMessage('This item has been saved.');
      return backlinksService.triggerAndWaitForBacklinksRefresh(eventId);
    }).then(function () {
      _collectionWatchCb2(watchedCollection);
      $scope.closeEditItemModal();
    }).catch(function (err) {
      $log.error('Could not save the doc', err);
      $rootScope.setFlashMessage('An error occurred. The item was not saved.', 'danger');
    }).finally(function () {
      $scope.isSavingEdit = false;
    });
  };
  $scope.closeEditItemModal = function () {
    $scope.showEditModal = false;
  };
  $scope.getTooltip = function (fpExtId) {
    if ($scope.type === 'icon' && idField === 'fp_asset' && !hasIconCorrectFormat(fpExtId)) {
      return $scope.formEssence.getRepresentation("".concat(fpExtId, "/file.png")).tooltip;
    }
    return $scope.formEssence.getRepresentation(fpExtId).tooltip;
  };
}]);